module.exports = __webpack_public_path__ + "static/img/02560_1.634b16b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_1.jpg
// module id = n47M
// module chunks = 1